import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Platform } from "@ionic/angular";
import { log } from "console";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/providers/alert.service";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { StorageService } from "src/app/providers/storage.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { environment } from "src/environments/environment";

@Component({
  selector: "sm-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class NewLoginComponent implements OnInit, OnDestroy {
  resendDisabled: boolean = true;
  resendTimer: number = 10;
  resendInterval: any;
  referralCode: string = "";
  registrationDone: boolean = false;
  @HostListener("window:resize", ["$event"])
  onResize(event: any): void {
    // Check screen width on window resize
    this.checkScreenWidth();
  }
  isFromHere: boolean = false;
  @ViewChild("submitButton", { read: ElementRef, static: true })
  submitButton!: ElementRef<HTMLButtonElement>;
  selectedCountry: any;
  toshowotp: boolean = false;
  otp: string[] = ["", "", "", "", "", ""];
  searchString: UntypedFormControl = new UntypedFormControl("");
  phone: any;
  countryCode: UntypedFormControl;
  _apiSubscription: Subscription;
  signInForm!: UntypedFormGroup;
  name: UntypedFormControl;
  dob: UntypedFormControl;
  gender: UntypedFormControl;
  address: UntypedFormControl;
  showProfileForm: boolean = false;
  toshowblockedmessage: boolean = false;
  blockedUserData: any;
  blockedUserGrievance: any;
  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  constructor(
    private dialog: MatDialog,
    private _alertService: AlertService,
    private _router: Router,
    private router: Router,
    private navservice: NavigationService,
    private _authService: AuthService,
    private _apiService: ApiService,
    private _storageService: StorageService,
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService,
    private ngZone: NgZone,
    private platform: Platform
  ) {
    setTimeout(() => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.places
      ) {
        console.error("Google Maps API failed to load in Safari <15.");
        return;
      }

      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.geocoder = new google.maps.Geocoder();
    }, 500);

    this.navservice.hideSidebarAndNav = true;
    this.countryCode = new UntypedFormControl(
      this.countryList.find((country) => country.dial_code === "+91"),
      Validators.required
    );
    this.selectedCountry = this.countryList.find(
      (country) => country.dial_code === "+91"
    );
    console.log(this.selectedCountry);
    this.name = new UntypedFormControl("", [Validators.required]);
    this.dob = new UntypedFormControl("");
    this.gender = new UntypedFormControl("", [Validators.required]);
    this.address = new UntypedFormControl("", [Validators.required]);
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE
      ) {
        console.log(resData);
        if (resData.result) {
          if (resData.result.errorcode == 0) {
            this.loaderservice.showLoader = false;

            //( make cases for mobile and laptop)

            this._router.navigateByUrl("/dashboard").then((_) => {
              this._alertService.onOpenSnackbar("Logged in successfully");
            });
          }
        } else {
          this._alertService.onOpenSnackbar(
            "Some error occured. Please try again."
          );
        }
      }
      if (resData.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
        console.log("resdata here:::>>>>>", JSON.stringify(resData.result));

        if (this.isFromHere) {
          this.isFromHere = false;
          this.loaderservice.showLoader = false;
          console.log(resData);

          if (resData.result) {
            this._storageService.setLocalStorageValue(
              SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER,
              this.userPhoneNumber
            );
            this._storageService.setLocalStorageValue(
              SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER,
              this.newUserPhoneNumber
            );
            this._storageService.setLocalStorageValue(
              SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE,
              this.selectedCountry.dial_code
            );

            if (
              resData.result.block_status &&
              resData.result.block_status == "2"
            ) {
              this.blockedUserData = resData.result;
              this.showProfileForm = false;
              this.toshowblockedmessage = true;
              this._authService.onSignOutWithoutRedirect();
            } else {
              if (resData.result.errorcode === 1) {
                this._storageService.setLocalStorageValue(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                  resData.result.accountHashID
                );

                //registered but no profile
                if (
                  !resData.result.profile_hash ||
                  resData.result.profile_hash == "null"
                ) {
                  this.showProfileForm = true;
                }

                //registered and having profie
                else if (
                  resData.result.profile_hash &&
                  resData.result.profile_hash != "null"
                ) {
                  //( make cases for mobile and laptop)

                  console.log("hereeeee");

                  this._router.navigateByUrl("/dashboard").then((_) => {
                    this._alertService.onOpenSnackbar("Logged in successfully");
                  });
                } else {
                  this._alertService.onOpenSnackbar(
                    "Some error occured. Please try again."
                  );
                }
                if(!this.platform.is('capacitor')){
                  this._apiService.getUserDetailToSetCookie(
                    localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
                  );

                }
                this._apiService.getUserDetail(
                  localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
                );
              } else if (resData.result.errorcode === 0) {
                this._storageService.setLocalStorageValue(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                  resData.result.accountHashID
                );
                this.showProfileForm = true;
              } else {
                this._alertService.onOpenSnackbar(resData.result.message, 4000);
              }
            }
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_SEND_UNBLOCK_REQUEST
      ) {
        if (resData.result) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            data: {
              title: "Success!",
              message: "Your request has been submitted successfully.",
              okbtn: "Ok",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            window.location.reload();
          });
        }
      }
    });
  }

  ngOnInit(): void {
    this.signInForm = new UntypedFormGroup({
      name: this.name,
      dob: this.dob,
      address: this.address,
    });
    this.route.queryParams.subscribe((data) => {
      console.log(data);
      this.referralCode = data.code;
    });
    if (this.referralCode) {
      sessionStorage.setItem("referralCode", this.referralCode);
    }
    
    this._authService.initRecaptcha(this.submitButton.nativeElement);
  }

  // List of countries with flag-icon classes or image URLs
  countries = [
    {
      code: "91",
      name: "India",
      flagClass: "flag-icon-in",
      imageUrl:
        "https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png",
    },
    {
      code: "1",
      name: "USA",
      flagClass: "flag-icon-in",
      imageUrl:
        "https://cdn.britannica.com/33/4833-004-828A9A84/Flag-United-States-of-America.jpg",
    },
    {
      code: "44",
      name: "UK",
      flagClass: "flag-icon-in",
      imageUrl:
        "https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png",
    },
    {
      code: "61",
      name: "Australia",
      flagClass: "flag-icon-in",
      imageUrl:
        "https://upload.wikimedia.org/wikipedia/commons/8/88/Flag_of_Australia_%28converted%29.svg",
    },
    {
      code: "33",
      name: "France",
      flagClass: "flag-icon-in",
      imageUrl:
        "https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/255px-Flag_of_France.svg.png",
    },
  ];

  onlogin() {
    this.toshowotp = true;
  }
  checkOtpDisability() {
    let isDisable = false;
    this.otp.forEach((item) => {
      if (!item || item == "") {
        isDisable = true;
      }
    });

    return isDisable;
  }
    isAddressNotSelectedFromList:boolean = false

  onRegister() {
     if(!this.formattedAddress || this.formattedAddress == undefined || this.formattedAddress == '' || this.formattedAddress == 'null'){
      this.isAddressNotSelectedFromList = true
    }
    else{
      let data = {
        profileInfo: {
          name: this.signInForm.value.name,
          phone: localStorage.getItem(SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER),
          country_code: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE
          ),
          gender: null,
          email: null,
          dob: this.signInForm.value.dob
            ? this.formatDate(
                new Date(this.signInForm.value.dob).toLocaleDateString()
              )
            : null,
          userType: 1,
          searchType: 1,
          addressInfo: {},
          origin: 'business'

        },
      };
  
      data.profileInfo.addressInfo = {
        addressLine: this.formattedAddress,
        city:
          this.selectedLocation.city && this.selectedLocation.city != "null"
            ? this.selectedLocation.city
            : "null",
        state:
          this.selectedLocation.state && this.selectedLocation.state != "null"
            ? this.selectedLocation.state
            : "null",
        country:
          this.selectedLocation.country && this.selectedLocation.country != "null"
            ? this.selectedLocation.country
            : "null",
        zip:
          this.selectedLocation.zip && this.selectedLocation.zip != "null"
            ? this.selectedLocation.zip
            : "null",
        lat: this.lat && this.lat != "null" ? this.lat : "null",
        lng: this.lng && this.lng != "null" ? this.lng : "null",
      };
      // Object.keys(data.profileInfo).forEach((key) => {
      //   if ((data.profileInfo as any)[key] === null) {
      //     delete (data.profileInfo as any)[key];
      //   }
      // });
      console.log(data);
  
      this.loaderservice.showLoader = true;
      this._apiService.updateUserProfile(data);

    }
  }

  onOTP() {
    console.log("new dashboard");
    this.router.navigate(["dashboard"]);
  }
  onSignIn() {
    this.sendingOtpStatus = true;
    const otpValue = this.otp.join("");
    console.log(otpValue);

    this._authService.onSignInWithPhone(otpValue).then((res) => {
      if (res) {
        localStorage.setItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID, res.user.uid);
        // localStorage.setItem('accTokenId', res.user.Aa);
        const apiBodyData = {
          versionCode: "1.0.0",
          appType: "web",
          appName: "business",
          countryCode: this.selectedCountry.dial_code,
        };
        console.log(JSON.stringify(apiBodyData));

        this.isFromHere = true;
        this.loaderservice.showLoader = true;
        this._apiService.checkUser(
          apiBodyData,
          res.user.uid,
          this.phone.toString()
        );
      }
    });
  }

  onbacklogin() {
    this.otp = ["", "", "", "", "", ""];
    this.otpReceived = false;
    const element = document.getElementById("first-form");
    if (element) {
      element.style.display = "block";
    }
  }

  onInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 1 && index < 5) {
      const nextInput = document.getElementById(`box${index + 1}`);

      nextInput?.focus();
    } else if (input.value.length === 0 && index > 0) {
      const prevInput = document.getElementById(`box${index - 1}`);
      prevInput?.focus();
    }
  }

  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
  sendingOtpStatus: boolean = false;
  otpReceived: boolean = false;
  onSendOTP() {
    this.otp = ["", "", "", "", "", ""];
    // this._authService.initRecaptcha(this.submitButton.nativeElement)
    console.log(this.userPhoneNumber);
    this.sendingOtpStatus = true;
    this._authService
      .onReceiveOTP(this.userPhoneNumber)
      .then((res) => {
        console.log("res", res);

        if (res === true) {
          const element = document.getElementById("first-form");
          if (element) {
            element.style.display = "none";
          }
          this.sendingOtpStatus = !res;
          this.otpReceived = res;
          setTimeout(() => {
            const nextInput = document.getElementById("box0");
            nextInput?.focus();
          }, 1);
          this.startResendCountdown()
        }
      })
      .catch((err) => {
        console.log("Login error trace", err);

        this.sendingOtpStatus = false;
        this.otpReceived = false;
      });
  }
  sendUnblockRequest() {
    let data = {
      message: this.blockedUserGrievance,
      block_hash: this.blockedUserData.block_hash_id,
      account_hash: this.blockedUserData.accountHashID,
    };

    console.log(data);

    this.loaderservice.showLoader = true;
    this._apiService.sendUnblockRequest(data);
    this.phone.toString();
  }
  public get userPhoneNumber() {
    return this.selectedCountry.dial_code + this.phone.toString();
  }
  public get newUserPhoneNumber() {
    return this.phone.toString();
  }

  /**LOCATION AUTOCOMPLETE FUNCTION */
  GoogleAutocomplete: any;
  geocoder: any;
  autocompleteItems: any = [];
  selectedLocation: any = [];
  formattedAddress: any;
  lat: any;
  lng: any;
  updateSearchResults() {
    console.log("Text enter");
        this.selectedLocation = []
    this.lat = this.lng = null
    this.formattedAddress = null
    if (
      this.signInForm.value.address == "" ||
      this.signInForm.value.address == null
    ) {
      this.autocompleteItems = [];
      return;
    }
    this.GoogleAutocomplete.getPlacePredictions(
      {
        input: this.signInForm.value.address,
      },
      (predictions: any, status: any) => {
        console.log(predictions, status);
        this.autocompleteItems = [];
        predictions.forEach((prediction: any) => {
          this.autocompleteItems.push(prediction);
        });
      }
    );
  }
  selectSearchResult(item: any) {
    console.log(item);
    this.autocompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this.ngZone.run(() => {
            // this.personalInfoForm.value.address = results[ 0 ].formatted_address;
            this.signInForm.patchValue({
              address: item.description,
            });
            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.storeLocation(
              results[0].address_components,
              item.description
            );
          });
        }
      }
    );
  }
  storeLocation(location: any, formatted_address: any) {
    console.log(location);

    const selectedLocation: any = {};
    location.forEach((element: any) => {
      console.log(element, element.types.includes("postal_code"));
      if (element.types.includes("postal_code")) {
        selectedLocation.zip = element.long_name;
      } else if (element.types.includes("country")) {
        selectedLocation.country = element.long_name;
      } else if (element.types.includes("administrative_area_level_1")) {
        selectedLocation.state = element.long_name;
      } else if (element.types.includes("locality")) {
        selectedLocation.city = element.long_name;
      } else if (element.types.includes("route")) {
        selectedLocation.address = element.long_name;
      }
    });
    this.formattedAddress = formatted_address;
    this.selectedLocation = selectedLocation;
        this.isAddressNotSelectedFromList = false

  }
  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  // SCREEN WIDTH CHECKER
  currentScreenWidth: any;
  private checkScreenWidth(): void {
    this.currentScreenWidth = window.innerWidth;
    console.log(this.currentScreenWidth);
  }

  openBusinessFeatures() {
    window.open(
      environment.base_lookzup_web_url + "/business/business-all-features",
      "_blank"
    );
  }

  onresend() {
    this.otp = ["", "", "", "", "", ""];
    // this._authService.initRecaptcha(this.submitButton.nativeElement)
    console.log(this.userPhoneNumber);
    this.sendingOtpStatus = true;
    this._authService
      .resendOTP(this.userPhoneNumber)
      .then((res) => {
        console.log("res", res);

        if (res === true) {
          const element = document.getElementById("first-form");
          if (element) {
            element.style.display = "none";
          }
          this.sendingOtpStatus = !res;
          this.otpReceived = res;
          setTimeout(() => {
            const nextInput = document.getElementById("box0");
            nextInput?.focus();
          }, 1);
          this.startResendCountdown()
        }
      })
      .catch((err) => {
        console.log("Login error trace", err);

        this.sendingOtpStatus = false;
        this.otpReceived = false;
      });
  }

  logout() {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to logout?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        this._authService.onSignOutWithoutRedirect();
        window.location.reload();
      }
    });
  }

  openCustomerWebsite() {
    window.open(environment.base_lookzup_market_website_url, "_blank");
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }


  startResendCountdown() {
  this.resendDisabled = true;
  this.resendTimer = 10;

  this.resendInterval = setInterval(() => {
    this.resendTimer--;

    if (this.resendTimer <= 0) {
      this.resendDisabled = false;
      clearInterval(this.resendInterval);
    }
  }, 1000);
}

handlePaste(event: ClipboardEvent) {
  console.log("inside paste handler");//dd
  
  event.preventDefault();
  const pastedText = event.clipboardData?.getData('text')?.replace(/\D/g, '') || '';
  const otpChars = pastedText.slice(0, 6).split('');

  otpChars.forEach((char, i) => {
    this.otp[i] = char;

    const input = document.getElementById(`box${i}`) as HTMLInputElement;
    if (input) {
      input.value = char;
    }
  });

  // Focus the next empty input (if any)
  const nextIndex = otpChars.length < 6 ? otpChars.length : 5;
  const nextInput = document.getElementById(`box${nextIndex}`) as HTMLInputElement;
  if (nextInput) {
    nextInput.focus();
  }
}


focusRealOtp(realInput: HTMLInputElement) {
  realInput.focus();
}

onOtpInput(value: string) {
  const cleanVal = value.replace(/\D/g, '').slice(0, 6);
  this.otp = cleanVal.split('');

  // Optionally: auto-submit when full OTP entered
  if (this.otp.length === 6) {
    console.log("OTP Complete:", cleanVal);
    // this.onSignIn();
  }
}

private prevFirstInputLength = 0;

onFirstInputChange(event: any) {
  const value = event.target.value.replace(/\D/g, '');

  // Detect actual paste (more than 1 char added instantly)
  if (value.length > 1 && value.length - this.prevFirstInputLength > 1) {
    value.slice(0, 6).split('').forEach((char: any, i: any) => {
      this.otp[i] = char;
      const input = document.getElementById(`box${i}`) as HTMLInputElement;
      if (input) input.value = char;
    });

    // Move focus to last box
    const lastInput = document.getElementById(`box5`) as HTMLInputElement;
    if (lastInput) lastInput.focus();
  } else {
    // Normal typing flow
    this.otp[0] = value;

    // Auto move to next if single digit typed
    if (value.length === 1) {
      const nextInput = document.getElementById('box1') as HTMLInputElement;
      if (nextInput) nextInput.focus();
    }
  }

  // Update tracker
  this.prevFirstInputLength = value.length;
}
}
